import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  private apiUrl = environment.apiFormUrl;
  // private azureFunctionUrl =
  //   'https://fa-bourne-bespoke-img-sas.azurewebsites.net/api/GenerateSASToken';
  private azureFunctionUrl =
    'https://fa-file-uploader.azurewebsites.net/api/GenerateUploadSASTokenBourneBespoke';

  constructor(private http: HttpClient) {}

  getSasUrl(blobName: string): Observable<any> {
    const requestUrl = `${this.azureFunctionUrl}?blobName=${blobName}`;
    return this.http.get<any>(requestUrl);
  }

  // Method to send form data to the backend
  submitForm(formData: FormData): Observable<any> {
    return this.http.post<any>(this.apiUrl, formData);
  }
}
